import React from 'react'
import "../Explore/Explore.css"
import ExploreBanner from './ExploreBanner'
import InnovativeTechnology from './InnovativeTechnology'
import NFCbusinessCard from './NFCbusinessCard'
import WhatWeOffer from './WhatWeOffer'
import MarketingGrowth from './MarketingGrowth'
import ExploreBusinessRewards from './ExploreBusinessRewards'
import PromoteMembersBusinesses from './PromoteMembersBusinesses'
import ReferEarnProgram from './ReferEarnProgram'
import SeoGeneral from '../BusinessPage/SeoGeneral';

const Explore = () => {
  const seoMetaData = {
    title: "Neoo Search | Vision 30 – 1M Digital Business Connections",
    description: "Discover Neoo Search’s business directory, free eco-friendly digital cards, and smart marketing tools. Join Vision 30 to grow your network and unlock new opportunities.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "Explore NeooSearch",
    url: process.env.REACT_APP_APPLICATION_URL + "/explore",
    keywords: "NeooSearch, Business directory UAE, Free Digital business card UAE, Eco-friendly business cards, Online business listing, Business networking platform, Digital profile sharing, promote businesses, Business growth tools, Vision 30 networking, UAE business promotion",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/explore"
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      <ExploreBanner />
      <InnovativeTechnology />
      <NFCbusinessCard />
      <WhatWeOffer />
      <MarketingGrowth />
      <ExploreBusinessRewards />
      <PromoteMembersBusinesses />
      <ReferEarnProgram />
    </>
  )
}

export default Explore